import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { FileChooser } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { PersonnelSignsManipulationView } from "./personnelSignsManipulation-view"

export class PersonnelSignsManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیم امضای پرسنل'
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.personnel = ObservableArray.create<personnel>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation));
        this.refresh();

    }
    GetDefaultView(): View <ViewModel> {
        return new PersonnelSignsManipulationView();
    }
    public getTypeId(): string {
        return "VM-1F3DBFEA-DA66-41F4-9422-9E10A561CCEE"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel;} private _personnel: ObservableArray<personnel>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetAllPersonnelWithSignInfo',{
                FurtherQueryInfo:filteringInformation
            });
            this.personnel.update(...result.Personnel.map(x=>{
                let r = new personnel(this);
                r.id=x.Id;
                r.name=x.Name;
                r.lastname=x.LastName;
                r.identificationCode=x.IdentificationCode;
                r.code = x.PersonnelCode;
                r.hasSign = x.HasSign;
                r.signFileName = x.SignFileName;
                r.isSignLoaded = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
}

export class personnel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastname(v: string) { this._lastname = v; } public get lastname(): string { return this._lastname;} private _lastname: string;
    public set identificationCode(v: string) { this._identificationCode = v; } public get identificationCode(): string { return this._identificationCode;} private _identificationCode: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set hasSign(v: boolean) { this._hasSign = v; } public get hasSign(): boolean { return this._hasSign;} private _hasSign: boolean;
    public set signFileName(v: string) { this._signFileName = v; } public get signFileName(): string { return this._signFileName;} private _signFileName: string;
    public set signFileData(v: string) { this._signFileData = v; } public get signFileData(): string { return this._signFileData;} private _signFileData: string;
    public set isSignLoaded(v: boolean) { this._isSignLoaded = v; } public get isSignLoaded(): boolean { return this._isSignLoaded;} private _isSignLoaded: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async loadSign(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetPersonnelSign',{
                PersonnelId:this.id
            });
            this.signFileName = result.SignFileName;
            this.signFileData = result.SignData;
            this.isSignLoaded = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }    

    async addSign(){
        let fileChooser =new  FileChooser();
        let choosedFile = await fileChooser.chooseFile();
        if(choosedFile.isChoosed){
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/SetPersonnelSign',{
                    PersonnelId:this.id,
                    SignFileName:choosedFile.filename,
                    SignInfo:choosedFile.fileContent
                });
                if(result.IsSuccessful){
                    this.signFileData = choosedFile.fileContent;
                    this.hasSign = true;
                    this.signFileName = choosedFile.filename,
                    this.isSignLoaded = true;
                    await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد','عملیات موفق');
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
    async removeSign(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/RemovePersonnelSign',{
                PersonnelId:this.id
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
        this.hasSign = false;
        this.isSignLoaded = false;
        this.signFileData = '';
        this.signFileName = ''
    }
}